module.exports = __webpack_public_path__ + "img/poster_0.6d99df76.jpg";